import { useLingui } from '@lingui/react/macro';

import IconValidation from '@/icons/Validation.svg';
import { BaseNotification } from '@/layouts/App/Navbar/NotificationList/components/BaseNotification/BaseNotification';
import type { TNotificationOfType } from '@/models/notification';

export const ArticleStatusDueAtManuallyUpdatedNotification = ({
  notification,
}: {
  notification: TNotificationOfType<'article_status_due_at_manually_updated'>;
}) => {
  const { t } = useLingui();
  const requestReference = notification.request.reference;

  const notificationLabel =
    notification.data.taskType === 'repair_article'
      ? t({
          id: 'notification.article-status-due-at-manually-updated.label',
          message: `The repair completion date has been updated of request ${requestReference}`,
        })
      : t({
          id: 'notification.article-status-due-at-manually-updated.exchange.label',
          message: `The exchange completion date has been updated of request ${requestReference}`,
        });
  const headerText =
    notification.data.taskType === 'repair_article'
      ? t({
          id: 'notification.article-status-due-at-manually-updated.header',
          message: `The repair completion date has been updated`,
        })
      : t({
          id: 'notification.article-status-due-at-manually-updated.exchange.header',
          message: `The exchange completion date has been updated`,
        });

  return (
    <BaseNotification
      notificationLabel={notificationLabel}
      icon={<IconValidation />}
      type="neutral"
      notification={notification}
      notificationHeader={() => headerText}
    />
  );
};
